import React from 'react';
import {View, Image, StyleSheet, TouchableOpacity, Linking} from 'react-native';

const HEADER_HEIGHT = 80;

const Header = () => {
  return (
    <View style={styles.headerContainer}>
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => Linking.openURL('https://www.wizzee.fr/')}>
        <Image
          source={{uri: '/assets/img/wizzee-site-logo.png'}}
          style={styles.logo}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    width: '100%',
    height: HEADER_HEIGHT,
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.08)',
  },
  logo: {
    width: 180,
    height: HEADER_HEIGHT,
  },
});

export default Header;
